var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"import-success"},[_c('CustomerImportSuccess',{attrs:{"modal":true,"customerImportData":_vm.stepProps,"totalCustomersToImport":_vm.stepProps.total},on:{"completed":_vm.handleCompleted}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }